export default "__VITE_ASSET__CH8q0QDz__"